import {textSizes} from '@stencil/build-theme/src/build-theme';
import styled from 'styled-components';

export const OuterWrapper = styled.div`
  background: #ffffff;
  margin-bottom: 0.8rem;
  ${props => props.isDesktop && 'padding: 2rem;'}
`;
export const Heading = styled.div`
  margin-bottom: 1.2rem;
  display: flex;
`;
export const IconWrapper = styled.img`
  width: ${props => (props.isDesktop ? '4rem' : '2.6rem')};
  height: ${props => (props.isDesktop ? '4rem' : '2.7rem')};
  margin-right: 1rem;
`;
export const TextWrapper = styled.div``;
export const Title = styled.h2`
  ${textSizes.LargeW3};
  ${props => props.isDesktop && `font-size: 2.2rem;`}
`;
export const SubTitle = styled.p`
  ${textSizes.SmallW1};
  color: #717171;
  ${props => props.isDesktop && `font-size: 1.6rem;`}
`;
export const TravelImpressionInfo = styled.div`
  color: #717171;
`;
export const TravelImpressionDetails = styled.span`
  ${textSizes.BaseW1};
  ${props => props.isDesktop && `font-size: 1.6rem;`}
`;

export const ExpandDetails = styled.a`
  line-height: normal;
  ${textSizes.BaseW3};
  color: #2276e3;
  display: block;
  margin-top: 0.5rem;
`;

export const Line = styled.div`
  height: 0.1rem;
  background: #e4e4e4;
  margin: 1.6rem 0 1.2rem;
`;
